import * as constants from './constants'

const headerInitialState = {
    isAuthVisible: false,
    hamburgerDropdownState: constants.HAMBURGER_DROPDOWN_STATE_MAIN,
    activeForm: constants.ACTIVE_FORM_LOGIN,
}

export default function reducer(state = headerInitialState, action) {
    switch (action.type) {
        case constants.CLOSE_AUTH:
            return {
                ...state,
                isAuthVisible: false,
            }
        case constants.AUTH_VISIBLE:
            return {
                ...state,
                isAuthVisible: true,
                activeForm: action.activeForm,
            }
        case constants.ACTIVE_FORM_LOGIN:
            return {
                ...state,
                activeForm: action.activeForm,
            }
        case constants.ACTIVE_FORM_SIGNUP:
            return {
                ...state,
                activeForm: action.activeForm,
            }
        case constants.SET_HAMBURGER_DROPDOWN_STATE:
            return {
                ...state,
                hamburgerDropdownState: action.state,
            }
        default:
            return state
    }
}
